<div #container *ngIf="filters" class="d-flex align-items-stretch" style="flex: 1" [ngClass]="{'mb-0': modalOptions.fullScreen || isReportMode, 'card': !isReportMode, 'report-view': isReportMode}">
    <ng-container *ngIf="!isReportMode">
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <app-connection-image [connectionType]="mainConnectionType"></app-connection-image>
                Charge point consumption
            </h4>
            <app-data-provider-date-range class="ms-2" *ngIf="modalOptions.fullScreen"></app-data-provider-date-range>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()"><i class="bi bi-arrows-angle-expand"></i></button>
            <app-chart-download-button [element]="container" [tableElement]="tableElement"
                                       [connectionTypes]="connectionTypes" [optionalDataTypes]="options.selectedWeatherTypes"></app-chart-download-button>
            <button type="button" class="btn" role="button" (click)="toggleShowAsTable()"><i class="bi" [ngClass]="options.showAsTable ? 'bi-bar-chart-line' : 'bi-table'"></i></button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <app-widget-options-menu title="Display settings" [anchorBelowTrigger]="modalOptions.fullScreen">
                <div class="dropdown-item" *ngIf="groupByEntityId && options.groupByEntityIdPossible && !onlyMetersSelected">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('groupByEntityId')"
                               [ngModel]="options.groupByEntityId" (ngModelChange)="groupByEntityIdChange($event)">
                        <label class="form-check-label" [for]="getInputId('groupByEntityId')">
                            Split by sub meters
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('checkboxCompareChargePoint')"
                               [ngModel]="options.compare.enabled" (ngModelChange)="compareChange($event)">
                        <div class="row">
                            <label class="form-check-label col-auto" [for]="getInputId('checkboxCompareChargePoint')">Compare with</label>
                            <app-select class="col px-0 notranslate" [ngModel]="options.compare" (ngModelChange)="comparedYearChange($event)"
                                        [options]="compareYearOptions" [small]="true" [formatter]="compareFormatter" [equalsFunction]="compareEquals"></app-select>
                        </div>
                    </div>
                </div>
                <app-widget-options-section title="Weather">
                <div *ngFor="let weatherType of evWeatherTypes" class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getWeatherInputId(weatherType)"
                               [checked]="isDataTypeSelected(weatherType)" (click)="toggleWeather(weatherType)">
                        <label class="form-check-label" [for]="getWeatherInputId(weatherType)">
                            {{appContext.measurementName(weatherType, false)}}
                        </label>
                    </div>
                </div>
                </app-widget-options-section>
            </app-widget-options-menu>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 mh-100" [ngClass]="{'p-0': options.showAsTable, 'card-body': !isReportMode}">
        <ng-container *ngIf="isReportMode else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
            <app-chart-table class="w-100" [dataProvider]="chartDataProvider"
                             [compare]="options.compare" [displayTimeRange]="displayTimeRange"></app-chart-table>
        </ng-container>
        <ng-template #notInReport>
            <app-chart-table class="w-100" [ngClass]="{'d-none': !options.showAsTable}"
                             [dataProvider]="chartDataProvider" [compare]="options.compare"
                             (tableElement)="tableElement = $event" [displayTimeRange]="displayTimeRange"></app-chart-table>
            <ng-container *ngIf="!options.showAsTable">
                <ng-container [ngTemplateOutlet]="chart"></ng-container>
            </ng-container>
        </ng-template>
    </div>
</div>

<ng-template #chart>
    <app-bar-chart class="chart h-100 w-100" [stacked]="true" [y1AxisMeasurement]="measurementUnit()"
                   style="flex: 1" [y2AxisMeasurement]="y2AxisTitle" [powerAxisMeasurement]="powerAxisTitle"
                   [dataProvider]="chartDataProvider" [showNormalAxis]="options.splitOffPeak" [showCompleteness]="options.showCompleteness"
                   [selectedWeatherTypes]="options.selectedWeatherTypes" [weatherTypes]="evWeatherTypes"
                   [fullScreen]="modalOptions.fullScreen" [skipPaddingX]="modalOptions.fullScreen || isReportMode"
                   [animationDuration]="isReportMode ? 0 : 1000" [directiveView]="this"
                   [customOnClick]="isReportMode ? false : undefined">
    </app-bar-chart>
</ng-template>
